import { createContext, useState, useEffect } from "react";
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  getUnifiedDeclarationAllLookups,
  getUnifiedDeclarationAllDetails,
  getStaticGovernorate,
} from "../adapters/apis/lookups/lookups";
import { get } from "../adapters/xhr/api";
import { validateBeforeSubmit } from "../components/UnifiedTaxDeclaration/helpers/validationHelper";
import { validateRequired } from "../helpers/Validation";
import {
  validateEgyptianPhoneNumberWithPhoneInput,
  validateNationalIDWithoutAgeLimit,
  validateEmail,
} from "../helpers/Validation";

const UnifiedTaxDeclarationContext = createContext({
  declarationRequest: null,
});

export const UnifiedTaxDeclarationProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isUnitInSameBuilding, setIsUnitInSameBuilding] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isGoingToFetchDeclarationData, setIsGoingToFetchDeclarationData] =
    useState(false);
  const [unitOwnerTypeErrorMessage, setUnitOwnerTypeErrorMessage] =
    useState("");
  const [staticGovs, setStaticGovs] = useState([]);
  const [staticPoliceStations, setStaticPoliceStations] = useState([]);
  const [buildingDate, setBuildingDate] = useState(null);
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [bulkdUploadError, setBulkdUploadError] = useState(null);
  const [phoneError, setPhoneError] = useState(null);

  const [user, setUser] = useState({
    first_name: "",
    father_name: "",
    grandfather_name: "",
    family_name: "",
    email: "",
    phone_number: "",
    nationality: { key: "", value: "" },
    national_id: "",
    passport_number: "",
    building_number: "",
    governorate_id: "",
    district_id: "",
    village_id: "",
    street_id: "",
    street_other: "",
    national_id_file: {},
    passport_number_file: {},
    profile: {},
  });
  const getUnitInitialValue = () => ({
    // property_type_id: null,
    search_using: 1,
    filter_search_type_id: null,
    property_type_id: null,
    governorate_id: null,
    district_id: null,
    village_id: null,
    village_other: null,
    region_id: null,
    region_other: null,
    real_estate_id: null,
    real_estate_other: null,
    real_estate_floor_id: null,
    unit_id: null,
    unit_other: null,
    real_estate_floor_other: null,
    reta_contact_about_unit: null,
    account_code: null,
    usage_type: null,
    area: null,
    unit_type_id: null,
    attachments: [],
    exempted: false,
    exemption_reason: null,
    law_number: null,
    law_year: null,
    market_value: null,
    ownership_deed: null,
    lease_contract: null,
    license_photo: null,
    submit_other_supporting_documents: null,
    supporting_documents: [],
    deleted_building_ids: [],

    total_land_area: null,
    land_ownership_legal_document: null,
    land_lease_agreement: null,
    vacantLands: [],

    installation_type_id: null,
    installation_type_other: null,
    is_taxpayer_owner_of_installation: null,
    installation_owner_name: null,
    contract_start: null,
    contract_end: null,
    // المنشآت الصناعية
    facility_name: null,
    activity_type: null,
    used_land_area: null,

    trade_name: null,
    view_type_id: null,
    license_date: null,
    // rooms_count: null,
    star_rating_id: null,
    has_sub_units: null,
    hotelUnits: [],
    copy_of_the_construction_permits: null,
    copy_of_the_operating_licenses: null,
    certificate_of_stardom_level: null,
    buildings: [],
    building: null,
    buildings_count: 1,
    ministry_burden: null,
    burden_activity_id: null,
    construction_license: null,
    operating_licenses: null,
    facility_lease_contracts: null,
    association_bylaws: null,
    facility_ownership_deed: null,
    building_permits: null,

    land_book_value: null,
    buildingProfile: null,
    known_build_num: null,
    manual_governorate_id: null,
    manual_policestation_id: null,
    manual_city: null,
    manual_district: null,
    manual_mogawra: null,
    manual_village: null,
    manual_street: null,
    manual_settlement: null,
    manual_known_build_num: null,
    manual_renin: null,
  });

  const declerationInitialValue = {
    id: null,
    viewMode: false,
    editMode: false,
    isUnitEditMode: false,
    isUnitViewMode: false,
    isShowOnlyUnit: false,
    isDeclarationSameUnit: false,
    activeTab: "residential",
    terms_conditions: false,
    user: null,
    units_count: null,
    applicant_role_id: null,
    applicant_role_other: null,
    joint_ownership_document: null,
    power_of_attorney: null,
    declaration_type_id: 1, // TODO fixed for now
    taxpayer: {
      type_id: null,
      first_name: null,
      last_name: null,
      nationality_id: null,
      national_id: null,
      national_id_attachment: null,
      passport_number: null,
      passport_attachment: null,
      name: null,
      commercial_register: null,
      commercial_register_attachment: null,
      tax_card_number: null,
      tax_card_attachment: null,
      other_attachment_name: null,
      other_attachment: null,
      phone: null,
      email: null,
    },

    unit: getUnitInitialValue(),

    data_accuracy_declaration: null,

    temp_number: null,
    status: null,

    residential_units: null,
  };
  const [validFields, setValidFields] = useState({
    applicant_role_id: false,
    applicant_role_other: false,

    type_id: false,
    first_name: false,
    last_name: false,
    nationality_id: false,
    national_id: false,
    national_id_attachment: false,
    passport_number: false,
    passport_attachment: false,
    name: false,
    commercial_register: false,
    commercial_register_attachment: false,
    tax_card_number: false,
    tax_card_attachment: false,
    other_attachment_name: false,
    other_attachment: false,

    property_type_id: false,
    governorate_id: false,
    district_id: false,
    village_id: false,
    village_other: false,
    region_id: false,
    region_other: false,
    real_estate_id: false,
    real_estate_other: false,
    real_estate_floor_id: false,
    unit_id: false,
    unit_other: false,
    real_estate_floor_other: false,
    reta_contact_about_unit: false,
    account_code: false,
    usage_type: false,
    area: false,
    unit_type_id: false,
    attachments: false,
    exempted_as_residence: false,
    market_value: false,
    land_book_value: false,

    submit_other_supporting_documents: false,
    name: false,
    file: false,

    power_of_attorney: false,
    joint_ownership_document: false,
    property_address: false,
    activity_address: false,

    data_accuracy_declaration: false,
    manual_governorate_id: false,
    manual_policestation_id: false,
    manual_known_build_num: false,
  });
  const [building, setBuilding] = useState(null);
  const [isDuplicateRenin, setIsDuplicateRenin] = useState("");

  const [declarationRequest, setDeclarationRequest] = useState(
    declerationInitialValue,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [applicantRoles, setApplicantRoles] = useState([]);
  const [declarationTypes, setDeclarationTypes] = useState([]);
  const [searchUsingTypes, setSearchUsingTypes] = useState([]);

  const [nationalitiesTypes, setNationalitiesTypes] = useState([]);
  const [govs, setGovs] = useState([]);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [taxpayerTypes, setTaxpayerTypes] = useState([]);
  const [residentialUnitTypes, setResidentialUnitTypes] = useState([]);
  const [commericalUnitTypes, setCommericalUnitTypes] = useState([]);
  const [unitAttachments, setUnitAttachments] = useState([]);
  const [showPropertyTypeModal, setShowPropertyTypeModal] = useState(false);
  const [realFloorOther, setRealFloorOther] = useState([]);
  const [reasonForExemption, setReasonForExemption] = useState([]);
  const [installationTypes, setInstallationTypes] = useState([]);

  const [doYouWantExtraAttachments, setDoYouWantExtraAttachments] = useState(
    [],
  );
  const [dataMismatchReasonLookup, setDataMismatchReasonLookup] = useState([]);
  const [declarationFilterSearchType, setDeclarationFilterSearchType] =
    useState([]);
  const [mapEnabled, setIsMapConfigEnable] = useState(true);
  const [manualEnabled, setIsManualConfigEnable] = useState(false);
  const [backendError, setBackendError] = useState(null);
  const [submissionError, setSubmissionError] = useState(null);
  const [isBuildingEditMode, setIsBuildingEditMode] = useState(false);
  const [error_new_user, setNewUserError] = useState(
    Object.keys(declarationRequest || {})?.reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {}),
  );

  const setError = (key, value) => {
    setNewUserError((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const clearAllUnitErrors = () => {
    setNewUserError(
      Object.keys(declarationRequest || {}).reduce((acc, key) => {
        acc[key] = "";
        return acc;
      }, {}),
    );

    setErrorBuilding(
      Object.keys(building || {}).reduce((acc, key) => {
        acc[key] = "";
        return acc;
      }, {}),
    );
  };

  const [errorBuilding, setErrorBuilding] = useState(
    Object.keys(building || {})?.reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {}),
  );

  useEffect(() => {
    checkVerfication();
    setIsDuplicateRenin("");
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified = response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const initializeData = async () => {
    setIsLoading(true);
    try {
      let url =
        "api/declaration-system/declaration-lookups/declaration-all-lookups";

      const [lookupRes] = await Promise.all([
        getUnifiedDeclarationAllLookups(url),
      ]);

      setApplicantRoles(lookupRes?.data?.data?.applicant_roles);
      setDeclarationTypes(lookupRes?.data?.data?.declaration_types);
      setGovs(lookupRes?.data?.data?.governorates);
      setNationalitiesTypes(lookupRes?.data?.data?.nationalities);
      setPropertyTypes(lookupRes?.data?.data?.property_types);
      setTaxpayerTypes(lookupRes?.data?.data?.taxpayer_types);
      setResidentialUnitTypes(lookupRes?.data?.data?.residential_unit_types);

      // setSearchUsingTypes(lookupRes?.data?.data?.search_using_types);
      setSearchUsingTypes([
        { id: 1, name: "العنوان التفصيلي" },
        { id: 2, name: "البحث بمدفوعة الكهرباء" },
      ]);

      setCommericalUnitTypes(lookupRes?.data?.data?.commercialUnitTypes);
      setUnitAttachments(lookupRes?.data?.data?.unit_attachments);

      setDoYouWantExtraAttachments(
        lookupRes?.data?.data?.DoYouWantExtraAttachmentsForRequestTypes,
      );

      setDataMismatchReasonLookup(
        lookupRes?.data?.data?.dataMismatchReasonLookup,
      );

      setDeclarationFilterSearchType(
        lookupRes?.data?.data?.declarationFilterSearchType,
      );

      setIsMapConfigEnable(lookupRes?.data?.data?.map_address_enabled);

      setIsManualConfigEnable(lookupRes?.data?.data?.manual_address_enable);

      setRealFloorOther(lookupRes?.data?.data?.real_estate_floors);

      setReasonForExemption(lookupRes?.data?.data?.exemptionReasons);

      setInstallationTypes(lookupRes?.data?.data?.installationTypes);

      setUser((prev) => ({
        ...prev,
        first_name: lookupRes?.data?.data?.user?.profile?.first_name,
        father_name:
          lookupRes?.data?.data?.user?.profile?.last_name ||
          lookupRes?.data?.data?.user?.profile?.second_name +
            " " +
            lookupRes?.data?.data?.user?.profile?.third_name +
            " " +
            lookupRes?.data?.data?.user?.profile?.fourth_name,
        email: lookupRes?.data?.data?.user.email,
        phone_number: lookupRes?.data?.data?.user?.profile?.mobile,
        nationality: {
          id: lookupRes?.data?.data?.user?.profile?.nationality.id,
          key: lookupRes?.data?.data?.user?.profile?.nationality.code,
          value: lookupRes?.data?.data?.user?.profile?.nationality.name,
        },
        national_id:
          lookupRes?.data?.data?.user?.profile?.national_id ||
          lookupRes?.data?.data?.user?.name,
        passport_number: lookupRes?.data?.data?.user?.profile?.passport_num,
        building_number: lookupRes?.data?.data?.user?.profile?.real_estate_num,
        governorate_id: lookupRes?.data?.data?.user?.profile?.governorate_id,
        district_id: lookupRes?.data?.data?.user?.profile?.district_id,
        village_id: lookupRes?.data?.data?.user?.profile?.village_id,
        street_id: lookupRes?.data?.data?.user?.profile?.street_id ?? -1,
        street_other: lookupRes?.data?.data?.user?.profile?.street_other,
        national_id_file:
          lookupRes?.data?.data?.user?.profile?.national_id_file?.[0] || null,
        passport_number_file:
          lookupRes?.data?.data?.user?.profile?.passport_num_file?.[0] || null,
        profile: lookupRes?.data?.data?.user.profile,
      }));

      if (!lookupRes?.data?.data?.can_create_declaration) {
        navigate("/tax-declaration/list-data");
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Initialization error:", error);
    }
  };

  const getDeclerationDetails = async () => {
    try {
      if (id) {
        let param;
        if (location.pathname.includes("/tax-declaration/details")) {
          param = "for_view=true";
        } else if (location.pathname.includes("/tax-declaration/update")) {
          param = "for_edit=true";
        }
        let url = `api/declaration-system/declarations/${id}?${param}`;

        const response = await getUnifiedDeclarationAllDetails(url);

        const { unit, ...restData } = response?.data?.data ?? {};

        setDeclarationRequest((prev) => ({
          ...prev,
          ...restData,
          activeTab: "residential",
        }));
        setIsGoingToFetchDeclarationData(false);
      }
    } catch (error) {
      setDeclarationRequest((prev) => ({
        ...prev,
        viewMode: true,
      }));
      console.error("Failed to get decelration data", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLoading(true);
    if (!isBulkUpload) {
      initializeData();
      if (
        (location?.pathname?.includes("/tax-declaration/update") ||
          location?.pathname?.includes("/tax-declaration/details")) &&
        id
      ) {
        getDeclerationDetails();
      }
    }
  }, [location.pathname, isBulkUpload]);

  useEffect(() => {
    setIsBulkUpload(false);
  }, [location.pathname]);

  useEffect(() => {
    if (
      !location.pathname.includes("/tax-declaration/add") &&
      !location.pathname.includes("/tax-declaration/update") &&
      !location.pathname.includes("/tax-declaration/details")
    ) {
      resetDeclarationRequest();
    }
  }, [location.pathname]);

  useEffect(() => {
    setIsUnitInSameBuilding(false);
    setDeclarationRequest((prev) => ({
      ...prev,
      isUnitEditMode: false,
      isUnitViewMode: false,
      isShowOnlyUnit: false,
    }));
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.includes("/tax-declaration/update")) {
      setDeclarationRequest((prev) => ({
        ...prev,
        unit: getUnitInitialValue(),
        activeTab: "residential",
      }));
    }
  }, [location.pathname]);

  const getManualGovernorate = async () => {
    try {
      const response = await getStaticGovernorate();
      setStaticGovs(response?.data?.data || []);
    } catch (error) {
      console.error("Failed to get decelration data", error);
    }
  };

  useEffect(() => {
    getManualGovernorate();
  }, []);

  const updateDeclarationRequest = (field, val) => {
    setDeclarationRequest({
      ...declarationRequest,
      [field]: val,
    });
  };

  const updateDeclarationTaxpayer = (key, value) => {
    setDeclarationRequest((prev) => ({
      ...prev,
      taxpayer: {
        ...prev.taxpayer,
        [key]: value,
      },
    }));
  };

  const updateDeclarationUnit = (key, value) => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev.unit,
        [key]: value,
      },
    }));
  };

  const resetDeclarationRequest = () => {
    setDeclarationRequest(declerationInitialValue);
  };

  const getLabelById = (id, arr) => {
    const match = arr?.find((item) => parseInt(item.id) === parseInt(id));
    return match ? match.name : null;
  };

  // const resetDeclarationForSameUnit = () => {
  //   setDeclarationRequest((prev) => ({
  //     ...prev,
  //     unit: {
  //       ...prev.unit,
  //       real_estate_floor_id: null,
  //       unit_id: null,
  //       unit_other: null,
  //       real_estate_floor_other: null,
  //       reta_contact_about_unit: null,
  //       account_code: null,
  //       usage_type: null,
  //       area: null,
  //       unit_type_id: null,
  //       attachment: null,
  //       exempted_as_residence: null,
  //       market_value: null,
  //       ownership_deed: null,
  //       lease_contract: null,
  //     },
  //   }));
  // };

  const resetDeclarationUnit = () => {
    return getUnitInitialValue();
  };

  const resetDeclarationForSameUnit = (prevUnit) => {
    return {
      ...prevUnit,
      real_estate_floor_id: null,
      unit_id: null,
      unit_other: null,
      real_estate_floor_other: null,
      reta_contact_about_unit: null,
      account_code: null,
      usage_type: null,
      area: null,
      unit_type_id: null,
      attachment: [],
      exempted: null,
      exemption_reason: null,
      law_number: null,
      law_year: null,
      market_value: null,
      ownership_deed: null,
      lease_contract: null,
    };
  };

  const isFormValidCheckForEditList = () => {
    let isValid = false;

    const validation = validateBeforeSubmit(
      declarationRequest,
      validateRequired,
      setValidFields,
      setError,
      validateNationalIDWithoutAgeLimit,
      setUnitOwnerTypeErrorMessage,
      true,
    );

    if (validation) {
      isValid = true;
    }

    if (
      parseInt(declarationRequest?.taxpayer?.type_id) === 1 &&
      (declarationRequest?.taxpayer?.phone ===
        declarationRequest?.taxpayer?.dial_code ||
        declarationRequest?.taxpayer?.phone === "" ||
        declarationRequest?.taxpayer?.phone === null ||
        declarationRequest?.taxpayer?.phone === "undefined")
    ) {
      setError("phone", "يجب ادخال رقم الهاتف المحمول");
      setValidFields((prev) => ({ ...prev, phone: false }));
      isValid = false;
    }

    if (
      declarationRequest?.taxpayer?.phone &&
      declarationRequest?.taxpayer?.phone !==
        declarationRequest?.taxpayer?.dial_code
    ) {
      if (
        declarationRequest?.taxpayer?.country_code === "eg" &&
        !validateEgyptianPhoneNumberWithPhoneInput(
          declarationRequest?.taxpayer?.phone,
        ) &&
        declarationRequest?.taxpayer?.phone !== "+20" &&
        declarationRequest?.taxpayer?.phone !== "20"
      ) {
        setError("phone", "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول ");
        setValidFields((prev) => ({ ...prev, phone: false }));
        isValid = false;
      } else {
        setError("phone", "");
        setValidFields((prev) => ({ ...prev, phone: true }));
      }
    }

    if (declarationRequest?.taxpayer?.email) {
      if (!validateEmail(declarationRequest?.taxpayer?.email)) {
        setError("email", "صيغة البريد الالكتروني غير صحيحة ");
        setValidFields((prev) => ({ ...prev, email: false }));
        isValid = false;
      } else {
        setError("email", "");
        setValidFields((prev) => ({ ...prev, email: true }));
      }
    }

    if (phoneError !== null) {
      isValid = false;
    }

    return isValid;
  };

  const buildingFullAddressDisplay = (profile, activeUnit, options = {}) => {
    if (
      !profile &&
      parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3
    )
      return "";
    const isManual =
      parseInt(declarationRequest?.unit?.filter_search_type_id) === 3;

    const addr = profile?.address || {};
    const { hideEmpty = true } = options;

    const fields = [
      [
        "المدينة",
        isManual
          ? activeUnit?.manual_city || ""
          : activeUnit?.correct_city_other || addr?.city || "",
      ],
      [
        "قسم/مركز الشرطة",
        isManual
          ? activeUnit?.manual_policestation_name ||
            getLabelById(
              activeUnit?.manual_policestation_id,
              staticPoliceStations,
            ) ||
            ""
          : addr?.policestation || "",
      ],
      [
        "الحي/المنطقة",
        isManual
          ? activeUnit?.manual_district || ""
          : activeUnit?.correct_district_other || addr?.district || "",
      ],
      [
        "القرية",
        isManual
          ? activeUnit?.manual_village || ""
          : activeUnit?.correct_village_other || addr?.village || "",
      ],
      [
        "المجاورة",
        isManual
          ? activeUnit?.manual_mogawra || ""
          : activeUnit?.correct_mogawra_other || addr?.mogawra || "",
      ],
      [
        "الشارع",
        isManual
          ? activeUnit?.manual_street || ""
          : activeUnit?.correct_street_other || addr?.street || "",
      ],
      [
        "التجمع السكني",
        isManual
          ? activeUnit?.manual_settlement || ""
          : activeUnit?.correct_settlement_other || addr?.settlement || "",
      ],
      [
        "رقم العقار",
        isManual
          ? activeUnit?.manual_known_build_num ||
            activeUnit?.building_manual_known_build_num ||
            ""
          : activeUnit?.known_build_num || profile?.number || "",
      ],
    ];

    const visibleFields = hideEmpty
      ? fields.filter(([, value]) => value && value !== "لا يوجد")
      : fields;

    return visibleFields.map(([label, value], index) => (
      <span key={label}>
        {hideEmpty ? value : value || "لا يوجد"}
        {index < visibleFields.length - 1 && "، "}
      </span>
    ));
  };

  return (
    <UnifiedTaxDeclarationContext.Provider
      value={{
        declarationRequest,
        updateDeclarationRequest,
        updateDeclarationTaxpayer,
        setDeclarationRequest,
        user,
        setUser,
        resetDeclarationRequest,
        updateDeclarationUnit,
        isUnitInSameBuilding,
        setIsUnitInSameBuilding,
        resetDeclarationUnit,
        resetDeclarationForSameUnit,
        declerationInitialValue,
        getUnitInitialValue,
        isSubmitting,
        setIsSubmitting,
        isLoading,
        applicantRoles,
        declarationTypes,
        nationalitiesTypes,
        setGovs,
        govs,
        searchUsingTypes,
        propertyTypes,
        setPropertyTypes,
        taxpayerTypes,
        residentialUnitTypes,
        commericalUnitTypes,
        unitAttachments,
        doYouWantExtraAttachments,
        showPropertyTypeModal,
        setShowPropertyTypeModal,
        realFloorOther,
        reasonForExemption,
        installationTypes,
        isGoingToFetchDeclarationData,
        setIsGoingToFetchDeclarationData,
        getDeclerationDetails,
        backendError,
        setBackendError,
        submissionError,
        setSubmissionError,
        error_new_user,
        setNewUserError,
        setError,
        building,
        setBuilding,
        isBuildingEditMode,
        setIsBuildingEditMode,
        isDuplicateRenin,
        setIsDuplicateRenin,
        unitOwnerTypeErrorMessage,
        setUnitOwnerTypeErrorMessage,
        validFields,
        setValidFields,
        isFormValidCheckForEditList,
        dataMismatchReasonLookup,
        declarationFilterSearchType,
        DoYouWantExtraAttachmentsForRequestTypes: doYouWantExtraAttachments,
        errorBuilding,
        setErrorBuilding,
        getLabelById,
        buildingFullAddressDisplay,
        staticGovs,
        setStaticGovs,
        staticPoliceStations,
        setStaticPoliceStations,
        buildingDate,
        setBuildingDate,
        clearAllUnitErrors,
        mapEnabled,
        manualEnabled,
        isBulkUpload,
        setIsBulkUpload,
        bulkdUploadError,
        setBulkdUploadError,
        phoneError,
        setPhoneError,
      }}
    >
      <Outlet />
    </UnifiedTaxDeclarationContext.Provider>
  );
};

export default UnifiedTaxDeclarationContext;
